import { render, staticRenderFns } from "./OnboardingCompanyDataForm.vue?vue&type=template&id=990f13fa"
import script from "./OnboardingCompanyDataForm.vue?vue&type=script&lang=js"
export * from "./OnboardingCompanyDataForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports